/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DeviceLifecycleHookType {
  DeviceLifecycleHookBeforeUpdating = 'BeforeUpdating',
  DeviceLifecycleHookAfterUpdating = 'AfterUpdating',
  DeviceLifecycleHookBeforeRebooting = 'BeforeRebooting',
  DeviceLifecycleHookAfterRebooting = 'AfterRebooting',
  DeviceLifecycleHookBeforeEnrolling = 'BeforeEnrolling',
  DeviceLifecycleHookAfterEnrolling = 'AfterEnrolling',
}
